import React from "react";
import "./Footer.css"; // Import CSS file for styling
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer id="footer" className="footer md-pb-70">
      <div className="footer-wrap">
        <div className="footer-body">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-md-6 col-12">
                <div className="footer-infor">
                  <div className="footer-logo">
                    <Link to="/">
                      <img src="images/logo/GeniusBabyLogo.png" alt="" />
                    </Link>
                  </div>
                  <ul>
                    <li>
                        Barkati Creation, <br />
                        Shree Arihant Complex, C5, 2nd floor, Gala no. 4,
                        Reti Bunder Road, Near Shilpa hotel
                        Kalher Pipe Line, Kalher,
                        Bhiwandi
                    </li>
                    <li>
                      <p>Email: <Link to="mailto:info@geniusbaby.com">info@geniusbaby.com</Link></p>
                    </li>
                    <li>
                      <p>Phone: <Link to="tel:+918080377402">(+91) 808-037-7402</Link></p>
                    </li>
                  </ul>
                  <Link to="contact" className="tf-btn btn-line">Get direction<i className="icon icon-arrow1-top-left"></i></Link>
                  <ul className="tf-social-icon d-flex gap-10">
                    <li><Link to="#" target="_blank" className="box-icon w_34 round social-facebook bg_line"><i className="icon fs-14 icon-fb"></i></Link></li>
                    <li><Link to="#" target="_blank" className="box-icon w_34 round social-twiter bg_line"><i className="icon fs-12 icon-Icon-x"></i></Link></li>
                    <li><Link to="https://www.instagram.com/geniusbaby_official?igsh=Y3BsbGgwbXliOXQ3" target="_blank" className="box-icon w_34 round social-instagram bg_line"><i className="icon fs-14 icon-instagram"></i></Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-12 footer-col-block">
                <div className="footer-heading footer-heading-desktop">
                  <h6>Help</h6>
                </div>
                <div className="footer-heading footer-heading-moblie">
                  <h6>Help</h6>
                </div>
                <ul className="footer-menu-list tf-collapse-content">
                  <li>
                    <Link to="privacy-policy" className="footer-menu_item">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="shipping-delivery" className="footer-menu_item">Shipping</Link>
                  </li>
                  <li>
                    <Link to="terms-conditions" className="footer-menu_item">Terms &amp; Conditions</Link>
                  </li>
                  <li>
                    <Link to="faq" className="footer-menu_item">FAQ’s</Link>
                  </li>
                  <li>
                    <Link to="wishlist" className="footer-menu_item">My Wishlist</Link>
                  </li>
                </ul>
              </div>
              <div className="col-xl-4 col-md-6 col-12 footer-col-block">
                <div className="footer-heading footer-heading-desktop">
                  <h6>About us</h6>
                </div>
                <div className="footer-heading footer-heading-moblie">
                  <h6>About us</h6>
                </div>
                <ul className="footer-menu-list tf-collapse-content">
                  <li>
                    <Link to="about" className="footer-menu_item">Our Story</Link>
                  </li>
                  <li>
                    <Link to="our-store" className="footer-menu_item">Visit Our Store</Link>
                  </li>
                  <li>
                    <Link to="contact" className="footer-menu_item">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="login" className="footer-menu_item">Account</Link>
                  </li>
                </ul>
              </div>
              {/* <div className="col-xl-3 col-md-6 col-12">
                <div className="footer-newsletter footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6>Sign Up for Email</h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6>Sign Up for Email</h6>
                  </div>
                  <div className="tf-collapse-content">
                    <div className="footer-menu_item">Sign up to get first dibs on new arrivals, sales, exclusive content, events and more!</div>
                    <form className="form-newsletter" id="subscribe-form" action="#" method="post" acceptCharset="utf-8" data-mailchimp="true">
                      <div id="subscribe-content">
                        <fieldset className="email">
                          <input type="email" name="email-form" id="subscribe-email" placeholder="Enter your email...." tabIndex="0" aria-required="true" />
                        </fieldset>
                        <div className="button-submit">
                          <button id="subscribe-button" className="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn" type="button">Subscribe<i className="icon icon-arrow1-top-left"></i></button>
                        </div>
                      </div>
                      <div id="subscribe-msg"></div>
                    </form>
                    
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bottom-wrap d-flex gap-20 flex-wrap justify-content-between align-items-center">
                  <div className="footer-menu_item">© 2024 Genius Baby. All Rights Reserved</div>
                  <div className="tf-payment">
                    <img src="images/payments/visa.png" alt="" />
                    {/* <img src="images/payments/img-1.png" alt="" /> */}
                    <img src="images/payments/img-2.png" alt="" />
                    {/* <img src="images/payments/img-3.png" alt="" />
                    <img src="images/payments/img-4.png" alt="" /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
